import { render } from "./JobSettings.vue?vue&type=template&id=21097527&scoped=true"
import script from "./JobSettings.vue?vue&type=script&lang=js"
export * from "./JobSettings.vue?vue&type=script&lang=js"

import "./JobSettings.vue?vue&type=style&index=0&id=21097527&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21097527"]])

export default __exports__